import React, { Fragment } from "react";
import SNETFooter from "shared/dist/components/SNETFooter";
import { FooterData } from "./footerContent";
import Header from "../Components/Header";
import Box from "@mui/material/Box";
import { useStyles } from "./styles";

const withLightHeaderAndFooter = (Component) => {
    return (props) => {
        const classes = useStyles();

        return (
            <Fragment>
                <Header />
                <Box className={classes.componentsContainer}>
                    <Component {...props} />
                </Box>
                <SNETFooter data={FooterData} />
            </Fragment>
        );
    };
};

export default withLightHeaderAndFooter;
